import React, {ReactNode} from 'react';

import {Popover} from 'reactstrap';

import {refreshPopoversPositions} from 'app/utils/browser';

import type {OverlayProps} from './AttachOverlay';

interface Props<T, X> {
  className?: string;
  overlayProps: OverlayProps;
  children: (children: {
    close: () => void;
    closeOnSuccess: (maybePromise: T) => Promise<T>;
    closeOnFinish: (maybePromise: X) => Promise<X>;
    refreshPosition: () => void;
  }) => ReactNode;
}

export function PopoverForm<T, X>({
  className,
  overlayProps,
  children,
}: Props<T, X>): JSX.Element {
  const close = overlayProps.toggle;

  const closeAndReturnValue = (v: any) => {
    close();
    return v;
  };

  /* closes the popover if the value is not an error */
  const closeOnSuccess = (anyValue: any) =>
    Promise.resolve(anyValue).then(closeAndReturnValue);

  /* closes the popover after resolving the value, error or not */
  const closeOnFinish = (anyValue: any) =>
    Promise.resolve(anyValue).then(closeAndReturnValue, (err) => {
      close();
      throw err;
    });

  refreshPopoversPositions();
  return (
    <Popover className={className} {...overlayProps}>
      {children({
        closeOnSuccess,
        closeOnFinish,
        close,
        refreshPosition: refreshPopoversPositions,
      })}
    </Popover>
  );
}
